import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;

  > h1 {
    margin-bottom: 32px;
    color: #2d2d2d;
    text-align: center;
    font-family: Mulish;
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    letter-spacing: 0.6px;
  }
`;
